import { render } from "./OmnisendIcon.vue?vue&type=template&id=e6827888"
import script from "./OmnisendIcon.vue?vue&type=script&lang=js"
export * from "./OmnisendIcon.vue?vue&type=script&lang=js"

import "./OmnisendIcon.vue?vue&type=style&index=0&id=e6827888&lang=css"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__